var GetAllClientList,
  GetHCPStaffList,
  GetHcpStaffClientList,
  GetHCPClientList,
  GetInvoiceList,
  GetHCPPassword,
  AssignProductsToHCPClient,
  add_prdoduct_from_shpify,
  index_val;
$(document).ready(function () {
  var url_string = window.location.href,
    url = new URL(url_string),
    hcp_billing_address = url.searchParams.get("hcp_billing_address"),
    menu_active = url.searchParams.get("menu");
  setTimeout(function () {
    hcp_billing_address &&
      ($(".custom_alert").show(),
      $(".custom_alert").text("Billing address updated successfully"),
      setTimeout(function () {
        custom_alert_hide();
      }, 6e3));
  }, 1500);
  function get_deshboard() {
    let interval = setInterval(function () {
      // Check if an element with the class "HcpStaffList" exists
      if (document.querySelector(".customer__title")) {
        // Call the function if the class is found
        $.ajax({
          url: base_url + "/shopifyapp_ajax_call/customer_role.php",
          data: { customerId },
          type: "GET",
          success: function (result) {
            // console.log("asd");
            // console.log(result);
            $(".customer__title").html(result),
              $("#AddHcpStaff").hide(),
              setTimeout(function () {
                $("div").hasClass("menu_list_items") &&
                  $(".default_logout_button").hide(),
                  $(".defaultLogout").hide(),
                  $(".menu_list_items").append(
                    '<a style="cursor: pointer;" class="PageHeader__Back Heading Text--subdued Link Link--primary u-h7 logout_class_click"  "  >Logout</a><br>'
                  );
                 if (window.location.pathname === '/account') {
                    if (!menu_active) {
                      if($(".my_client").length){
                        $(".my_client").trigger("click");
                      }
                      if($(".my_h_client").length){
                        $(".my_h_client").trigger("click");
                      }
                    }
                  }
              }, 200);
          },
          error: function () {
            console.log("zxc");
            console.log("error");
          },
        });
        // Clear the interval after calling the function
        clearInterval(interval);
      }
    }, 1000); // Check every 1000 milliseconds (1 second)
  }

  get_deshboard();
  (AssignProductsToHCPClient = function () {
    $("#AddHcpStaff").hide(),
      $(".my_menu").css("color", "#9d9d9d"),
      $(".assign_products").css("color", "black"),
      $.ajax({
        url: base_url + "/shopifyapp_ajax_call/hcp_assign_products.php",
        data: { customerId },
        type: "POST",
        success: function (result) {
          $("#HcpStaffList").html(result);
        },
        error: function () {
          console.log("error");
        },
      });
  }),
    $(document).on("click", ".assign-products", function () {
      var checkedValues = [];
      $(".check-box-assign-product:checked").each(function () {
        checkedValues.push($(this).val());
      }),
        $.ajax({
          url:
            base_url + "/shopifyapp_ajax_call/update_assign_hcp_products.php",
          data: { customerId, checkedValues },
          type: "POST",
          success: function (result) {
            result
              ? (console.log(result),
                Swal.fire({
                  icon: "success",
                  title: "Success...",
                  text: "Products Updated Successfully...",
                }))
              : Swal.fire({
                  icon: "error",
                  title: "Ops...",
                  text: "Their an error please try again..",
                });
          },
          error: function () {
            console.log("error");
          },
        });
    }),
    (GetHCPStaffList = function () {
  const interval = setInterval(() => {
    // Check if the target element exists
    if ($("#HcpStaffList").length > 0) {
      clearInterval(interval); // Stop checking once found

      // Update menu styles
      $(".my_menu").css("color", "#9d9d9d");
      $(".my_staff").css("color", "black");

      // Run AJAX call
      $.ajax({
        url: base_url + "/shopifyapp_ajax_call/hcp_staff_list.php",
        data: { customerId: customerId, tag: "hcp" },
        type: "GET",
        success: function (result) {
          $("#HcpStaffList").html(result);
          $("#AddHcpStaff").show();
          $(".append_back_butoon").hide();
        },
        error: function () {
          console.error("Error loading HCP staff list.");
        },
      });
    }
  }, 500); // check every 0.5 seconds
}
),
    (GetHcpStaffClientList = function () {
      $(".my_menu").css("color", "#9d9d9d"),
        $(".my_h_client").css("color", "black"),
        $.ajax({
          url: base_url + "/shopifyapp_ajax_call/client_list_for_hcp_staff.php",
          data: { customerId },
          type: "GET",
          success: function (result) {
            $("#HcpStaffList").html(result),
              $("#AddHcpStaff").hide(),
              $(".append_back_butoon").hide();
          },
          error: function () {
            console.log("error");
          },
        });
    }),
    (GetHCPClientList = function () {
      $(".my_menu").css("color", "#9d9d9d"),
        $(".my_client").css("color", "black"),
        $.ajax({
          url: base_url + "/shopifyapp_ajax_call/client_list_for_hcp_staff.php",
          data: { customerId },
          type: "GET",
          success: function (result) {
            $("p").hasClass("table_scroll_details") ||
              $("#HcpStaffList").before(
                '<p class="table_scroll_details" style="text-align:center;">(Scroll the table right to see all columns)</p><hr>'
              ),
              $("#HcpStaffList").html(result),
              $("#AddHcpStaff").hide(),
              $(".append_back_butoon").hide();
          },
          error: function () {
            console.log("error");
          },
        });
    }),
    (GetInvoiceList = function () {
      $(".my_menu").css("color", "#9d9d9d"),
        $(".my_invoice").css("color", "black"),
        $("#AddHcpStaff").css("display", "none"),
        $.ajax({
          url: base_url + "/shopifyapp_ajax_call/hcp_client_invoice.php",
          data: { customerId },
          type: "GET",
          success: function (result) {
            $("#HcpStaffList").html(result),
              $("#AddHcpStaff").hide(),
              $(".append_back_butoon").hide();
          },
          error: function () {
            console.log("error");
          },
        });
    });
  function custom_alert_hide() {
    $(".custom_alert").hide();
  }
  
  if (menu_active) {
  const intervalMenu = setInterval(() => {
    // Check if element with the given class exists
    if ($(".menu_list_items").length > 0) {
      clearInterval(intervalMenu); // Stop checking once found

      // Trigger click and update color
      $("." + menu_active).trigger("click");
      $("." + menu_active).css("color", "black");
    }
  }, 500); // check every 0.5 seconds
}

$(document).on("change", "#hcpstaff", function () {

    let $select = $(this);
    let selectedValue = $select.val();

    // If no valid option selected
    if (!selectedValue || selectedValue === "0") {
        Swal.fire({
            icon: "warning",
            title: "Warning",
            text: "Please select a staff member.",
            customClass: {
                confirmButton: "Button Button--primary",
            },
        });
        return;
    }

    // Extract staff ID and client ID
    let parts = selectedValue.split("_");
    let staff_id = parts[0];
    let client_id = parts[1];

    // Disable dropdown + show loading text
    let originalText = $select.find("option:selected").text();
    $select.prop("disabled", true);
    $select.find("option:selected").text("Assigning...");

    $.ajax({
        url: base_url + "/Customers/set_hcp_for_client.php",
        type: "GET",
        data: { staff_id: staff_id, id_client: client_id },

        success: function (response) {
            Swal.fire({
                icon: "success",
                title: "Success",
                text: "Staff has been assigned successfully.",
            });
        },

        error: function () {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to assign staff. Please try again.",
            });
        },

        complete: function () {
            // Re-enable dropdown + restore text
            $select.prop("disabled", false);
            $select.find("option:selected").text(originalText);
        }
    });

});
$(document).on("change", ".hcpdietitian", function () {

    let $select = $(this);
    let selectedValue = $select.val();

    // If no valid option selected
    if (!selectedValue || selectedValue === "0") {
        Swal.fire({
            icon: "warning",
            title: "Warning",
            text: "Please select a Dietitian",
            customClass: {
                confirmButton: "Button Button--primary",
            },
        });
        return;
    }

    // Extract staff ID and client ID
    let parts = selectedValue.split("_");
    let dietitian_id = parts[0];
    let client_id = parts[1];

    // Disable dropdown + show loading text
    let originalText = $select.find("option:selected").text();
    $select.prop("disabled", true);
    $select.find("option:selected").text("Assigning...");

    $.ajax({
        url: base_url + "/Customers/set_dietitian_for_client.php",
        type: "GET",
        data: { dietitian_id: dietitian_id, id_client: client_id },

        success: function (response) {
          if(response === 'success'){

            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Dietitian has been assigned successfully.",
               customClass: {
                confirmButton: "Button Button--primary",
            },
            });
          }else{
            Swal.fire({
              icon: "error",
              title: "Error",
              text: response,
               customClass: {
                confirmButton: "Button Button--primary",
            },
            });

          }
        },

        error: function () {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to assign Dietitan. Please try again.",
                customClass: {
                confirmButton: "Button Button--primary",
            },
            });
        },

        complete: function () {
            // Re-enable dropdown + restore text
            $select.prop("disabled", false);
            $select.find("option:selected").text(originalText);
        }
    });

});

    // $(document).on("click", ".assigned_staff_click", function () {
    //   var assigned_staff_id = $(this).attr("id"),
    //     hcpstaff_select = $(".hcpstaff_" + assigned_staff_id).val();
    //   if (hcpstaff_select == null){
    //     Swal.fire({
    //         icon: "warning",
    //         title: "Warning",
    //         text: "Please select Staff member..",
    //        customClass: {
    //         confirmButton: "Button Button--primary",
    //       },
    //       });
    //   } else {
    //     var array_select_staff = hcpstaff_select.split("_"),
    //       staff_id_hcp = array_select_staff[0],
    //       client_id_hcp = array_select_staff[1];
    //     $.ajax({
    //       url: base_url + "/Customers/set_hcp_for_client.php",
    //       data: { staff_id: staff_id_hcp, id_client: client_id_hcp },
    //       type: "GET",
    //       success: function (result) {
    //         $(".custom_alert").show(),
    //           $(".custom_alert").text("Staff assigned successfully"),
    //           setTimeout(function () {
    //             custom_alert_hide();
    //           }, 6e3);
    //       },
    //       error: function () {
    //         console.log("error");
    //       },
    //     });
    //   }
    // });
    $(document).on("click", ".edit_order_hcp", function () {
      var edit_order_customer_id = $(this).attr("customer_id"),
        edit_order_order_id = $(this).attr("order_id");
      $.ajax({
        url: base_url + "/order_invoice/edit_order_hcp.php",
        data: {
          customer_id: edit_order_customer_id,
          order_id: edit_order_order_id,
        },
        type: "GET",
        success: function (result) {
          $("#HcpStaffList").html(result),
            $(".dropdown_list_v").prop("disabled", !0),
            (index_val = parseInt($(".coun_value").val())),
            $(".back-button-order").html(
              $(".Customer_Id_edit_order_div").html()
            );
        },
        error: function () {
          console.log("error");
        },
      });
    });
  function sub_total() {
    (total_val = 0),
      $(".total_find").each(function () {
        total_val = parseFloat(total_val) + parseFloat($(this).val());
      });
    var sub_total2 = total_val.toFixed(2);
    $(".sub_total_text").text("$" + sub_total2),
      $(".sub_total_val").val(sub_total2);
  }
  sub_total(),
    $(document).on("click", ".delete_item_order", function (e) {
      e.preventDefault();
      var trCount = $(".customer_address_items").find("tr").length;
      trCount > 1
        ? Swal.fire({
            title: "Are you sure?",
            text: "You want to delete it!",
            icon: "warning",
            showCancelButton: !0,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel!",
          }).then((result) => {
            if (result.isConfirmed) {
              var id = $(this).attr("id");
              $("#row_" + id).fadeOut(1e3);
              var total_val_p_del = parseFloat(
                  $(".prodtct_total_val_" + id).val()
                ),
                subtotal_old_val = parseFloat($(".sub_total_val").val());
              $(".sub_total_text").text(
                "$" + (subtotal_old_val - total_val_p_del).toFixed(2)
              ),
                $(".sub_total_val").val(
                  (subtotal_old_val - total_val_p_del).toFixed(2)
                ),
                setTimeout(function () {
                  $("#row_" + id).insertAfter(
                    '<div class="Segment__Title" ></div>'
                  ),
                    $("#row_" + id).html(""),
                    sub_total();
                }, 2e3);
            }
          })
        : Swal.fire({
            icon: "error",
            title: "Ops...",
            text: "Unable to delelte the last product ",
          });
    }),
    $(document).on("click", ".button-plus", function (e) {
      var id = $(this).attr("id"),
        old_val = parseInt($("#qty_" + id).val()),
        new_val = parseInt(old_val + 1);
      $("#qty_" + id).val(new_val);
      var get_p_price = parseFloat($(".prodtct_p_" + id).val()),
        new_total_p1 = get_p_price * new_val,
        new_total_p = new_total_p1.toFixed(2);
      $(".prodtct_total_val_" + id).val(new_total_p),
        $(".prodtct_total_text_" + id).text("$" + new_total_p),
        sub_total();
    }),
    $(document).on("click", ".button-minus", function (e) {
      var id = $(this).attr("id"),
        old_val = parseFloat($("#qty_" + id).val()),
        new_val = parseFloat(old_val - 1);
      new_val < 1 && (new_val = 1), $("#qty_" + id).val(new_val);
      var get_p_price = $(".prodtct_p_" + id).val(),
        new_total_p1 = get_p_price * new_val,
        new_total_p = new_total_p1.toFixed(2);
      $(".prodtct_total_val_" + id).val(new_total_p),
        $(".prodtct_total_text_" + id).text("$" + new_total_p),
        sub_total();
    }),
    $(document).on("change", ".dropdown_list_p", function () {
      hide_product_alert();
      var check_varient = !0,
        product_id = $(this).val(),
        recurring_week_qty = $(".recurring_week").val();
      product_id == 0 ||
        $.ajax({
          url:
            base_url + "/order_invoice/fetch_product_from_shopify_backend.php",
          data: {
            check_varient,
            recurring_week: recurring_week_qty,
            product_id_for_v: product_id,
          },
          async: !1,
          type: "GET",
          success: function (data) {
            var data = $.parseJSON(data);
            $(".dropdown_list_v").html(data[0]),
              $("#qty_a_p_q").val(data[1]),
              $(".dropdown_list_v").prop("disabled", !1);
          },
          error: function (result) {
            console.log(["error order listing", result]);
          },
        });
    }),
    $(document).on("change", ".dropdown_list_v", function () {
      hide_product_alert();
    }),
    (add_prdoduct_from_shpify = function () {
      var product_id = $(".dropdown_list_p").val(),
        varient_id = $(".dropdown_list_v").val();
      if (product_id == 0) {
        $(".product_alert").text("Please select product"),
          $(".product_alert").fadeIn(1e3);
        return;
      } else if (varient_id == 0) {
        $(".product_alert").fadeIn(1e3),
          $(".product_alert").text("Please select varient");
        return;
      } else
        varient_id &&
          $(".varient_id_c").each(function () {
            var all_varient_id = $(this).val();
            varient_id == all_varient_id &&
              ($(".product_alert").fadeIn(1e3),
              $(".product_alert").text("Varient already exists"),
              exit);
          });
      var qty_a_p_q = $("#qty_a_p_q").val(),
        new_index_val = parseInt(index_val++),
        old_value = new_index_val;
      new_index_val++,
        $.ajax({
          url:
            base_url + "/order_invoice/fetch_product_from_shopify_backend.php",
          data: {
            product_id,
            product_qty: qty_a_p_q,
            index_val,
            varient_id,
            shopify_check: !0,
          },
          async: !1,
          type: "GET",
          success: function (data) {
            $("#row_" + old_value).after(data),
              $(".dropdown_list_p").prop("disabled", !1),
              $(".product_alert").fadeIn(1e3),
              $(".product_alert").removeClass("Alert--error"),
              $(".product_alert").addClass("Alert--success"),
              $(".product_alert").text("Product added successfully...!"),
              sub_total();
          },
          error: function (result) {
            console.log(["error order listing", result]);
          },
        });
    });
  function hide_product_alert() {
    $(".product_alert").fadeOut(1e3);
  }
  (GetHCPPassword = function () {
    $(".my_menu").css("color", "#9d9d9d"),
      $(".my_password").css("color", "black"),
      $.ajax({
        url: base_url + "/reset_password/reset_password_template.php",
        type: "GET",
        success: function (result) {
          $("#HcpStaffList").html(result), $("#AddHcpStaff").hide();
        },
        error: function () {
          console.log("error");
        },
      });
  }),
    $(document).on("keydown", "#password12", function () {
      $("#password12").prop("type", "password");
    }),
    $(document).on("keydown", "#confirm_password12", function () {
      $("#confirm_password12").prop("type", "password");
    }),
    $(document).on("click", "#password12", function () {
      $("#password12").prop("type", "password");
    }),
    $(document).on("click", "#confirm_password12", function () {
      $("#confirm_password12").prop("type", "password");
    }),
    $(document).on("click", ".reset_button", function (e) {
      e.preventDefault(),
        $(".Form__Input").each(function () {
          if ($(this).val() == "") {
            var input_name = $(this).attr("placeholder");
            $(".password_rest_alert").removeClass("Alert--success"),
              $(".password_rest_alert").addClass("Alert--error"),
              $(".password_rest_alert").text(input_name + " field is required"),
              $(".password_rest_alert").show(),
              $(".password_rest_alert").fadeOut(8e3),
              exit;
          }
        }),
        $("#password12").val() === $("#confirm_password12").val()
          ? ($(".password_rest_alert").hide(), reset_password())
          : ($(".password_rest_alert").removeClass("Alert--success"),
            $(".password_rest_alert").addClass("Alert--error"),
            $(".password_rest_alert").show(),
            $(".password_rest_alert").text("Password doesnot match"),
            $(".password_rest_alert").fadeOut(8e3));
    });

    function reset_password() {
  var form = document.reset_pass_form,
    dataString = $(form).serialize();

  $.ajax({
    method: "POST",
    url:
      base_url +
      "/reset_password/reset_password.php?customer_id=" +
      customerId,
    data: dataString,
    success: function (data) {

      data = data.trim();

      if (data === "success") {

        // SUCCESS UI
        $(".password_rest_alert")
          .removeClass("Alert--error")
          .addClass("Alert--success")
          .show()
          .text("Password reset successfully");

        // Clear fields
        $("#password12").val("");
        $("#confirm_password12").val("");

       
        // Build dynamic return URL
        const currentPath = encodeURIComponent(window.location.pathname + window.location.search);
        const redirectUrl =
          "/account/login?return_url=" + currentPath;

        // Redirect after 2 seconds
        setTimeout(function () {
          window.location.href = redirectUrl;
        }, 100);

      } else {

        // ERROR UI
        $(".password_rest_alert")
          .removeClass("Alert--success")
          .addClass("Alert--error")
          .show()
          .text(data);
      }
    },

    error: function () {
      $(".password_rest_alert")
        .removeClass("Alert--success")
        .addClass("Alert--error")
        .show()
        .text("Something went wrong. Please try again.");
    },
  });
}


  (GetAllClientList = function () {
    $.ajax({
      url: base_url + "/shopifyapp_ajax_call/all_client_list.php",
      data: { tag: "nutritionists", customer_id: customerId },
      type: "GET",
      success: function (result) {
       
         $(".my_menu").css("color", "#9d9d9d"),
        $(".my_client").css("color", "black"),
        $("#HcpStaffList").html(result);
      },
      error: function () {
        console.log("error");
      },
    });
  }),
    setInterval(function () {
      $("div").hasClass("new_msg_unread") &&
        $.ajax({
          url: base_url + "/chats/ajax_call_unread_msg.php",
          data: { customer_id: customerId, group_id: customerId, t: (window.EWH_PORTAL_TOKEN || "") },
          type: "GET",
          success: function (result) {
            console.log(result),
              result == 0
                ? $(".new_msg_unread").text("")
                : $(".new_msg_unread").text(result);
          },
          error: function () {
            console.log("error");
          },
        });
    }, 60000),
    setInterval(function () {
      $(".new_msg_unread_hcp").each(function () {
        var group_id_hcp = $(this).attr("group_id");
        value_add = "";
        var result;
        $.ajax({
          url: base_url + "/chats/ajax_call_unread_msg.php",
          data: { customer_id: customerId, group_id: group_id_hcp },
          type: "GET",
          success: function (result2) {
            result2 != 0 && $("#unread_" + group_id_hcp).text(result2);
          },
          error: function () {
            console.log("error");
          },
        });
      });
    }, 5e3),
    $(document).on("click", ".logout_class_click", function () {
      localStorage.setItem(
        "insert_update_customer_from_shopift_todb",
        "logout"
      ),
        localStorage.clear(),
        (window.location.href = "/account/logout");
    }),
    $(document).on("click", ".mark_invoices", function () {
      var arraymy = [];
      $("input:checkbox[name=invice_check_box]:checked").each(function () {
        arraymy.push($(this).val());
      }),
        console.log(arraymy),
        localStorage.setItem("invoices_numbers_arr", JSON.stringify(arraymy)),
        (window.location.href = "/pages/mark-invoices-as-paid");
    });
    $(document).on("click", ".my_pr_recommendation", function () {
      $(".my_menu").css("color", "#9d9d9d");
        $(this).css("color", "black");

        let customer_id = customerId;
        let dietitiansCheck = false;
        if($(this).attr("id") === "dietitian"){
          customer_id = $(this).attr("client_id");
          dietitiansCheck =  true;
        }
        console.log(customer_id);
        $("#HcpStaffList").show();
        $(".Secound_div_loader").hide();
        $.ajax({
          url: base_url + "/saveimages/getimageDeatis.php",
          data: { customerId: customer_id, dietitiansCheck },
          type: "GET",
          success: function (result) {
            $("#HcpStaffList").html(result);
          },
          error: function () {
            console.log("error");
          },
        });
    }),
    $(document).on("click", ".uploadRecommendationsBtn", function () {
      $("#HcpStaffList").hide();
        loaderr_show("Uploading your recommendation...");
        let client_id = $(this).attr('client_id') ? $(this).attr('client_id') : "false";
        SubmitedImageIntoDataBase(client_id);
    });
    $(document).on("click", ".uploadRecommendedProductBtn", function () {
      $("#HcpStaffList").hide();
        loaderr_show("Uploading recommendation product...");
        let client_id = $(this).attr('client_id') ? $(this).attr('client_id') : "false";
        uploadProductToRecommendation(client_id);
    });

  function loaderr_show(message) {
    var messagee = `<div class="p-3 m_top-body body_servey hide_message Secound_div_loader" style="text-align: center;">
                          <div class="spinner-border loader" style="color:#454545"></div><br><br>
                          <div class="col-12 fw-bold">
                              <h4 class="SectionHeader__Heading Heading Heading_apna u-h1 customerLoaderheading">${message}</h4>
                          </div>
                    </div>`;
    $("div").hasClass("Secound_div_loader")
      ? $(".customerLoaderheading").text(message)
      : $(".HcpStaffList").append(messagee),
      $(".Secound_div_loader").show();
  }

  async function SubmitedImageIntoDataBase(client_id = "false", dietician_check = false, message = true) {

  loaderr_show("Uploading your recommendation...");

  const fileInput = $("#PreRecommendedImage")[0];
  const file = fileInput?.files[0];


  if (file) {



  // Prepare form data
  const formData = new FormData();
  formData.append("files[]", file);
  formData.append("customerId", customerId);
  formData.append("customerIdHCPClient", client_id);
  
  if($('#recommended_product').val() && $('#recommended_product').val() != ''){
    formData.append("newProductId", $('#recommended_product').val());

  }

  // Return a Promise (success OR failure)
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${base_url}/saveimages/saveImage.php`,
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
      async: true,

      success: function (response) {
        if (message) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Recommendation Uploaded",
          });

          console.log("Upload successful:", response);

          if ($(".my_pr_recommendation").length) {
            $(".my_pr_recommendation").click();
          } else {
            $("#HcpStaffList").show();
            $(".Secound_div_loader").hide();
            $(".my_client").click();
          }
        }
        if(response != ''){
          $("#HcpStaffList").show();
          $(".Secound_div_loader").hide();
          reject(new Error(`Unable to Submit the File - ${response}`));
        }
        resolve(response);
      },

      error: function (xhr, status, error) {
        console.error("Upload failed:", error);
        reject(new Error(error || "Upload failed"));
      },
    });
  });
  }else{
    if (!dietician_check) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please select a file to upload",
      });

      $("#HcpStaffList").show();
      $(".Secound_div_loader").hide();
      return Promise.reject(new Error("No file selected"));
    }

  }

}


  async function uploadProductToRecommendation(client_id = "false") {
      // Check if the select exists before appending
      var recommendedProduct = $('#recommended_product').val();

        let fileInput = $("#PreRecommendedImage")[0];
        let file = fileInput.files[0];


      if ($('.dietitians_recommended_products').length && !recommendedProduct) {
        recommendedProduct = $('.dietitians_recommended_products').attr('productids') || "";
      }

      // ✅ Normalize to array
      if (typeof recommendedProduct === "string") {
        recommendedProduct = recommendedProduct.split(',').filter(Boolean);
      } else if (!Array.isArray(recommendedProduct)) {
        recommendedProduct = [];
      }


      console.log(recommendedProduct);

      if($('.recommendation_link').length){
      } else {
          
          if (!file){

            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Please select a file to upload",
            });
            $("#HcpStaffList").show();
            $(".Secound_div_loader").hide();
            return;
          }
      }

      if (recommendedProduct.length > 0) {

        try {
          const result = await SubmitedImageIntoDataBase(client_id,$('.recommendation_link').length,false);

          

          loaderr_show("Uploading recommendation product...");

          $.ajax({
            url: base_url + "/saveimages/upload_product.php",
            type: "GET",
            data: {customerId:client_id , product_id:recommendedProduct},
            async: true,
            success: function (response) {
              const res = JSON.parse(response);
              console.log(response.success)

              if ($(".my_pr_recommendation").length) {
                $(".my_pr_recommendation").click();
              } else {
                $("#HcpStaffList").show();
                $(".Secound_div_loader").hide();
              }

              if (res.success) {
                Swal.fire({
                  icon: "success",
                  title: "Success",
                  text: res.message || "Recommended Product has been Updated",
                });
                $(".my_client").click();

                } else {
                  Swal.fire({
                    icon: "error",
                    title: "Failed",
                    text: res.message || "Something went wrong, please try again.",
                  });
                }

              
            },
            error: function (xhr, status, error) {
              console.error("Upload failed:", error);
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: error,
              });
            },
          });

        } catch (error) {
          console.error("Upload failed:", error.message);

          // You can show an error alert here if needed
          Swal.fire({ icon: "error", title: "Upload failed", text: error.message });
        }
      }else{
         Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please select a product to upload",
      });

      $("#HcpStaffList").show();
      $(".Secound_div_loader").hide();
    }
  }
  
  $(document).on('click', '.newOrderAlert', function (e) {
    e.preventDefault();

    Swal.fire({
        icon: 'warning',
        title: 'Notice',
        text: "An order can only be placed once you have completed the Nutrition Screening Questionnaire or Uploaded a Dietitian's recommendation as it is a requirement for the Support at Home Funding",
        confirmButtonText: 'OK'
    });
  });

  $(document).on('click', '.recommendation_link_form', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    showRecommendationPopup(
      'https://gpn.qni.mybluehost.me/eat-well-health/test/download.php'
    );

    return false;
  });

  function showRecommendationPopup(downloadUrl) {
    Swal.fire({
      icon: 'info',
      title: "You're About to Download the Recommendation Form",
      html: `
        Click <strong>Download Form</strong> to download the recommendation form as a PDF directly to your device.<br><br>
        After downloading, please fill out the form on your device. Once completed, return here and upload the filled form to complete the process.
      `,
      showCancelButton: true,
      confirmButtonText: 'Download Form',
      cancelButtonText: 'Cancel',
      allowOutsideClick: false,
      customClass: { confirmButton: "Button Button--primary", cancelButton: "Button Button--secondary" }
    }).then((result) => {
      if (result.isConfirmed && downloadUrl) {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = downloadUrl;
        document.body.appendChild(iframe);

        setTimeout(() => iframe.remove(), 3000);
      }
    });
  }


  $(document).on('click', '.new_subscription_order', function (e) {
      e.preventDefault();
      Swal.fire({
        title: 'How would you like to place your order?',
        html: `
            <div style="text-align:left; margin-top:10px;">
                <input type="radio" id="newOrder" name="orderType" value="new" checked>
                <label for="newOrder">New Order</label><br>
                <input type="radio" id="subscriptionOrder" name="orderType" value="subscription">
                <label for="subscriptionOrder">Subscription Order</label>
            </div>
        `,
        showCancelButton: true,
        confirmButtonText: 'Continue',
        cancelButtonText: 'Cancel',
        customClass: {
            confirmButton: 'Button Button--primary',
            cancelButton: 'Button Button--secondary'
        },
        preConfirm: () => {
            const selected = document.querySelector('input[name="orderType"]:checked').value;
            return selected; // pass the selected value to then()
        }
    }).then((result) => {
        if (result.isConfirmed) {
            const orderType = result.value;
            console.log('Selected order type:', orderType);
            if(orderType === 'new') {
            window.location.href = '/pages/product-recomendation?only_products=true';
            } else if(orderType === 'subscription') {
                window.location.href = '/pages/product-recomendation?only_products=true&order_type=subscription';
            }
        }
    });


  });

      function generateSmartEmail(firstName, lastName) {

            // Clean input (lowercase + remove spaces)
            const first = (firstName || "").trim().toLowerCase();
            const last = (lastName || "").trim().toLowerCase();

            // Generate 4 digit random number
            const randomDigits = Math.floor(1000 + Math.random() * 9000);

            // Build email
            return first + "." + last + randomDigits + "@ewhops.com.au";
          }

    $(document).on("change",".custom-check__input", function () {

            const $box = $(".custom-check__box");
            const $emailInput = $(".email_c");

            const firstName = $(".first_name_c").val();
            const lastName  = $(".last_name_c").val();

            if ($(this).is(":checked")) {

              $box.addClass("is-checked");
              
              // Only generate if names exist
              if (firstName && lastName) {
                const email = generateSmartEmail(firstName, lastName);
                if ($emailInput.length) {
                  $emailInput.val(email);
                  $emailInput.attr("readonly", true);
                }
              }else {

                $box.removeClass("is-checked");

                if ($emailInput.length) {
                  $emailInput.val("");
                  $emailInput.removeAttr("readonly");
                }

                // Append custom HTML at the TOP
                const extraHtml = `
                    <p style="font-size: 12px !important;" id="custom-top-message" class=" Form__Alert Alert Alert--error SectionHeader--center">Please provide your first and last name to generate an email address.</p>
                `;

                $('.swal2-html-container').prepend(extraHtml);

                    $('#custom-top-message').fadeOut(3000, function () {
                        $(this).remove();
                    });
              }

            } else {

              $box.removeClass("is-checked");

              if ($emailInput.length) {
                $emailInput.val("");
                $emailInput.removeAttr("readonly");
              }

            }

          });

  $(document).on("click", ".add_client_nutritionists", function () {

        // Check if clicked element has 'pharmacist' class
        let userKey = $(this).hasClass("pharmacist") 
            ? 'Customer_pharmacist_Id' 
            : 'Customer_Dietitian_Id';

         let swalTitle = 'Support at Home - Client'; // 2026-07-27 Jen P5 5.5: dietitian branch wrongly said 'Support At Home Provider Form'

          let randomEmailDiv = $(this).hasClass("pharmacist") 
            ? `<div class="custom-check">
                  <div class="custom-check__item">
                    <label class="custom-check__wrapper">
                      <!-- Checkbox -->
                      <input type="checkbox" id="no_email_checkbox" class="custom-check__input">

                      <!-- Custom box -->
                      <span class="custom-check__box"></span>

                      <!-- Text -->
                      <span class="custom-check__text"> I don’t want to provide an email </span>
                    </label>
                  </div>
                </div>` 
            : '';

        var hcp_company_d;
          $.ajax({
            url: base_url + '/Customers/hcp_list.php',
            data: {
              check_exists: true,
            },
            async: false,
            type: 'GET',
            success: function (res1) {
              hcp_company_d = res1;
            },
            error: function (result) {
              console.log(['error order listing', result]);
            },
          });
        Swal.fire({
          title: swalTitle,
          html: `
              <input type="hidden" id="logged_user_id" value="${customerId}">


              <form id="requetHCPForm">               
                <div class="Form__Item">
                  <input
                    type="text"
                    class="Form__Input first_name_c"
                    name="customer[first_name]"
                    aria-label="{{ 'customer.register.first_name' | t }}"
                    placeholder="First Name"
                    autofocus
                  >
                  <label class="Form__FloatingLabel">First Name</label>
                </div>

                <div class="Form__Item">
                  <input
                    type="text"
                    class="Form__Input last_name_c"
                    name="customer[last_name]"
                    aria-label="{{ 'customer.register.last_name' | t }}"
                    placeholder="Last Name"
                  >
                  <label class="Form__FloatingLabel">Last Name</label>
                </div>

                ${randomEmailDiv}

                <div class="Form__Item">
                  <input
                    type="email"
                    class="Form__Input email_c"
                    name="customer[email]"
                    aria-label="{{ 'customer.register.email' | t }}"
                    placeholder="Email"
                    required="required"
                    autocomplete="off"
                  >
                  <label class="Form__FloatingLabel">Email</label>
                </div>

                <div class="Form__Item">
                  <input
                    type="number"
                    class="Form__Input phone_number_c"
                    name="customer[note][phone-number]"
                    aria-label="Phone Number"
                    placeholder="+61 Enter Phone Number"
                    required="required"
                  >
                  <label class="Form__FloatingLabel">Phone Number</label>
                </div>

                <div class="Form__Item  ageCareNumberInput">
                <input 
                  type="text" class="Form__Input ageCareNumber" 
                  name="customer[note][age-care-number]" 
                  aria-label="Age Care Number" 
                  placeholder="Age Care Number" 
                  autofocus required
                  >
                  <label class="Form__FloatingLabel">Age Care Number</label>
                </div>
                <div class="Form__Item Secondary_show_hide Secondary_hcp_customer">
                  <input
                    type="text"
                    class="Form__Input secondary_first_name"
                    name="customer[note][Secondary-FirstName]"
                    aria-label="Secondary Contact - First Name"
                    placeholder="Secondary Contact - First Name"
                    autofocus
                  >
                  <label class="Form__FloatingLabel">Secondary Contact - First Name</label>
                </div>
                <div class="Form__Item Secondary_show_hide Secondary_hcp_customer">
                  <input
                    type="text"
                    class="Form__Input "
                    name="customer[note][Secondary-LastName]"
                    aria-label="Secondary Contact - Last Name"
                    placeholder="Secondary Contact - Last Name"
                    autofocus
                  >
                  <label class="Form__FloatingLabel">Secondary Contact - Last Name</label>
                </div>

                <div class="Form__Item Secondary_show_hide Secondary_hcp_customer">
                  <input
                    type="email"
                    class="Form__Input optimal_secondary_email"
                    name="customer[note][Secondary-Email]"
                    aria-label="Secondary Contact - Email"
                    placeholder="Secondary Contact - Email"
                    autofocus
                  >
                  <label class="Form__FloatingLabel">Secondary Contact - Email</label>
                </div>

                <div class="Form__Item Secondary_show_hide Secondary_hcp_customer ">
                  <input
                    type="number"
                    class="Form__Input"
                    name="customer[note][Secondary-PhoneNumber]"
                    aria-label="Secondary Contact - Phone Number"
                    placeholder="Secondary Contact - Phone Number"
                    autofocus
                  >
                  <label class="Form__FloatingLabel">Secondary Contact - Phone Number</label>
                </div>

                <div class="Form__Item  Secondary_hcp_company ">
                </div>
                <div class="Form__Item">
                  <input
                    type="password"
                    class="Form__Input"
                    name="customer[password]"
                    aria-label="{{ 'customer.register.password' | t }}"
                    placeholder="Password"
                    required="required"
                    minlength="5"
                  >
                  <label class="Form__FloatingLabel">Password</label>
                </div>
              <form>
                  `,
          confirmButtonText: 'Submit',
          confirmButtonColor: '#000',
          showLoaderOnConfirm: true,
          focusConfirm: false,
          didOpen: () => {

              // 1️⃣ Insert company dropdown HTML
              $('.Secondary_hcp_company').after(hcp_company_d);
              $(document).on('change', '#Select_Company', function () {
                  let hcpId = $(this).val();

                  // Always remove previous dynamic fields
                  $('.newcustom_fields').remove();
                  $('.compnay_staff_slect_div').remove(); 

                  // Case 1: If selected HCP is 1357911 → Show custom fields, NO staff dropdown
                  if (hcpId === '1357911') {

                      let html = `
                          <div class="Form__Item newcustom_fields">
                              <input type="text" class="Form__Input" id="companyContactName" placeholder="Company Name" required>
                              <label class="Form__FloatingLabel">Company Name</label>
                          </div>

                          <div class="Form__Item newcustom_fields">
                              <input type="text" class="Form__Input" id="stName" placeholder="Staff Name" required>
                              <label class="Form__FloatingLabel">Staff Name</label>
                          </div>
                          <div class="Form__Item newcustom_fields">
                              <input type="text" class="Form__Input" id="stContact" placeholder="Staff Contact" required>
                              <label class="Form__FloatingLabel">Staff Contact</label>
                          </div>
                          <div class="Form__Item newcustom_fields">
                              <input type="email" class="Form__Input" id="stEmail" placeholder="Staff Email" required>
                              <label class="Form__FloatingLabel">Staff Email</label>
                          </div>`;

                      $('.compnay_slect_div').after(html);

                      return; // stop here – DO NOT load staff list
                  }

                  // Case 2: If HCP is anything else → Load staff list
                  let loadingBox = `
                      <div class="Form__Item compnay_staff_slect_div">
                          <select class="Form__Input Select_Company_staff">
                              <option value="0">Loading...</option>
                          </select>
                          <label class="Form__FloatingLabel">Select Staff</label>
                      </div>`;

                  $('.compnay_slect_div').after(loadingBox);

                  // Load staff via AJAX
                  setTimeout(function () {
                      $.ajax({
                          url: base_url + '/Customers/hcp_staff_list.php',
                          type: 'GET',
                          data: { hcp_id: hcpId, registrationPage: true },
                          success: function (hcpStaffList) {
                              $('.compnay_staff_slect_div').remove();
                              $('.compnay_slect_div').after(hcpStaffList);
                          },
                          error: function (err) {
                              console.log("Error fetching staff list:", err);
                          }
                      });
                  }, 1);
              });

              $(document).on('change', '.Select_Company_staff', function () {
                var val = $(this).val();
                $('.newcustom_fields').remove();
                if (val === 'HCPNL') {
                    var html = `
                        <div class="Form__Item newcustom_fields">
                            <input type="text" class="Form__Input" id="stName" placeholder="Staff Name" required>
                            <label class="Form__FloatingLabel">Staff Name</label>
                        </div>
                        <div class="Form__Item newcustom_fields">
                            <input type="text" class="Form__Input" id="stContact" placeholder="Staff Contact" required>
                            <label class="Form__FloatingLabel">Staff Contact</label>
                        </div>
                        <div class="Form__Item newcustom_fields">
                            <input type="text" class="Form__Input" id="stEmail" placeholder="Staff Email" required>
                            <label class="Form__FloatingLabel">Staff Email</label>
                        </div>`;
                    $('.compnay_staff_slect_div').after(html);
                }
            });

            

          },
          preConfirm: async () => {
            const loggedUserId = Swal.getPopup().querySelector('#logged_user_id')?.value || '';
            const hcpFirstName = Swal.getPopup().querySelector('.first_name_c')?.value || '';
            const hcpLastName = Swal.getPopup().querySelector('.last_name_c')?.value || '';
            const hcpEmail = Swal.getPopup().querySelector('.email_c')?.value || '';
            const hcpPhoneNumber = Swal.getPopup().querySelector('.phone_number_c')?.value || '';
            const tags = "HCPClient";

            const secondaryFirst  = Swal.getPopup().querySelector('.secondary_first_name')?.value.trim() || '';
            const secondaryLast   = Swal.getPopup().querySelector('input[name="customer[note][Secondary-LastName]"]')?.value.trim() || '';
            const secondaryEmail  = Swal.getPopup().querySelector('.optimal_secondary_email')?.value.trim() || '';
            const secondaryPhone  = Swal.getPopup().querySelector('input[name="customer[note][Secondary-PhoneNumber]"]')?.value.trim() || '';
            const hcpselect = document.getElementById('Select_Company').value || '';

            const staffMail  =  Swal.getPopup().querySelector('#stEmail')?.value || '';
            const staffPhone = Swal.getPopup().querySelector('#stContact')?.value || '';
            const randomEmailValue = $('#no_email_checkbox').length 
                                        ? true 
                                        : false;

            // Other info goes to notes
            const notes = {
                [userKey]: loggedUserId,
                'age-care-number': Swal.getPopup().querySelector('.ageCareNumber')?.value || '',
                'phone-number': hcpPhoneNumber,

                'Secondary-FirstName': secondaryFirst,
                'Secondary-LastName': secondaryLast,
                'Secondary-Email': secondaryEmail,
                'Secondary-PhoneNumber': secondaryPhone,
                
                'Customer-HCP': document.getElementById('Select_Company').value || '',
                'Customer-HCPStaff-Id': Swal.getPopup().querySelector('#Select_Company_staff')?.value || '',
                'companyContactname': Swal.getPopup().querySelector('#companyContactName')?.value || '',
                'staff-name': Swal.getPopup().querySelector('#stName')?.value || '',
                'staff-contact': staffPhone,
                'staff-email': staffMail,

                'random-no-email': randomEmailValue,
            };

    

            if (!hcpFirstName) {
              Swal.showValidationMessage('Please enter Support At Home Provider Name Client');
              return false;
            }

            if (!hcpEmail) {
              Swal.showValidationMessage('Please enter a valid Support At Home Provider Client Email');
              return false;
            }

            if(hcpEmail !== ""){
              const checkvalidateEmail = isValidEmail(hcpEmail);
              
              if(!checkvalidateEmail){
                Swal.showValidationMessage("HCP Email format is be like (xyz@abc.abc)");
                return false;
              }
            }

            if (!hcpselect || hcpselect.trim() === "" || hcpselect === "Please select a Support at Home provider") {
                Swal.showValidationMessage("Please select Support At Home Provider");
                return false;
            }
                        
            if (hcpPhoneNumber && secondaryPhone) { // both must have a value
                if (hcpPhoneNumber.trim() === secondaryPhone.trim()) {
                    Swal.showValidationMessage("Secondary Phone Number must be different from Primary Phone Number");
                    return false;
                }
            }

            if (hcpPhoneNumber && staffPhone) { // both must have a value
                if (hcpPhoneNumber.trim() === staffPhone.trim()) {
                    Swal.showValidationMessage("Staff Phone Number must be different from Primary Phone Number");
                    return false;
                }
            }

            if (secondaryPhone && staffPhone) { // both must have a value
                if (secondaryPhone.trim() === staffPhone.trim()) {
                    Swal.showValidationMessage("Staff Phone Number must be different from Secondary Phone Number");
                    return false;
                }
            }

            if (hcpEmail && secondaryEmail) { // both must have a value
                if (hcpEmail.trim() === secondaryEmail.trim()) {
                    Swal.showValidationMessage("Secondary Email must be different from Primary Email");
                    return false;
                }
            }

            if (hcpEmail && staffMail) { // both must have a value
                if (hcpEmail.trim() === staffMail.trim()) {
                    Swal.showValidationMessage("Staff Email must be different from Primary Email");
                    return false;
                }
            }

            if (secondaryEmail && staffMail) { // both must have a value
                if (secondaryEmail.trim() === staffMail.trim()) {
                    Swal.showValidationMessage("Staff Email must be different from Secondary Email");
                    return false;
                }
            }

            const phoneCheck = await validatePhoneNumber(hcpPhoneNumber);

            if (!phoneCheck.valid) {
                Swal.showValidationMessage(phoneCheck.message);
                return false;  // stops the submit
            }

            // check the mail exists
            checMail = await checkhcpemail(hcpEmail);
            if (checMail) {
              Swal.showValidationMessage(`The Email already exists`);
              return false;
              
            }

            if (secondaryEmail !== '') {

                if (secondaryFirst === '') {
                    Swal.showValidationMessage('Secondary First Name is required when Secondary Email is entered.');
                    return false;
                }

                if (secondaryLast === '') {
                    Swal.showValidationMessage('Secondary Last Name is required when Secondary Email is entered.');
                    return false;
                }

                if (secondaryPhone === '') {
                    Swal.showValidationMessage('Secondary Phone Number is required when Secondary Email is entered.');
                    return false;
                }
            }

            if (secondaryEmail !== "") {
              const checkvalidateEmail = isValidEmail(secondaryEmail);
              
              if(!checkvalidateEmail){
                Swal.showValidationMessage("Secondary Email format is be like (xyz@abc.abc)");
                return false;
              }
              
              const checkSecondaryEmail = await checkhcpemail(secondaryEmail);
                if (checkSecondaryEmail === true) {
                    Swal.showValidationMessage("Secondary Email already exists in the system.");
                    return false;
                }

            }

            if (secondaryPhone !== "") {
                const phoneCheck = await validatePhoneNumber(secondaryPhone);

                if (!phoneCheck.valid) {
                    Swal.showValidationMessage(phoneCheck.message);
                    return false;  // stops the submit
                }
            }            

            if(staffMail !== ""){
              const checkvalidateEmail = isValidEmail(staffMail);
              
              if(!checkvalidateEmail){
                Swal.showValidationMessage("Staff Email format is be like (xyz@abc.abc)");
                return false;
              }

              const checkSecondaryEmail = await checkhcpemail(staffMail);
                if (checkSecondaryEmail === true) {
                    Swal.showValidationMessage("Staff Email already exists in the system.");
                    return false;
                }
            }

            if(staffPhone !== ""){
              const phoneCheck = await validatePhoneNumber(hcpPhoneNumber);

              if (!phoneCheck.valid) {
                  Swal.showValidationMessage(phoneCheck.message);
                  return false;  // stops the submit
              }
            }

           

            
            // return new Promise((resolve) => {

            //     const previewData = {
            //         first_name: hcpFirstName,
            //         last_name: hcpLastName,
            //         email: hcpEmail,
            //         phone: hcpPhoneNumber,
            //         HCP: hcpselect,
            //         tags: tags,
            //         notes: notes
            //     };

            //     console.log("DATA BEFORE SUBMIT:", previewData);

            //      let htmlPreview = `
            //         <div style="text-align:left; font-size:13px;">
            //             <b>First Name:</b> ${previewData.first_name}<br>
            //             <b>Last Name:</b> ${previewData.last_name}<br>
            //             <b>Email:</b> ${previewData.email}<br>
            //             <b>Phone:</b> ${previewData.phone}<br>
            //             <b>HCP:</b> ${previewData.HCP}<br>
            //             <b>Tags:</b> ${previewData.tags}<br>
            //             <b>Notes:</b> ${JSON.stringify(previewData.notes)}
            //         </div>
            //     `;

            //     // 🔥 Show the preview IN THE VALIDATION MESSAGE (red box)
            //     Swal.showValidationMessage(`Preview (Not Saved):<br><br>${htmlPreview}`);

            //     // 🔥 Stop submit completely
            //     resolve(false);
            // });

            return new Promise((resolve, reject) => {
                $.ajax({
                    url: base_url + '/shopifyapp_ajax_call/saveHCPCient.php',
                    method: 'POST',
                    data: { 
                        first_name: hcpFirstName,
                        last_name: hcpLastName,
                        email: hcpEmail,
                        phone: hcpPhoneNumber,
                        tags: tags,
                        note: JSON.stringify(notes)
                    },
                    success: function () { 
                        resolve({ hcpFirstName }); 
                    },
                    error: function () { 
                        Swal.showValidationMessage('Failed to save client'); 
                        reject(); 
                    }
                });
            });
          },
        }).then((result) => {
          if (result.isConfirmed) {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              html: `<p style="text-align:left;">Hi ${result.value.hcpFirstName}, your account has been created.</p>`,
              customClass: {
                confirmButton: "Button Button--primary",
            },
            });
            setTimeout(()=>{
              $(".my_client").trigger("click");
            },5000);

          }
        });

        $('.swal2-modal').css('width', '50%');
        $('.swal2-actions').css('width', '100%');
        $('.swal2-confirm').css('width', '100%');
            
        async function checkhcpemail(hcpEmail) {
          try {
            const res1 = await $.ajax({
              url: base_url + '/Customers/check_customer_email.php',
              data: {
                customer_HCP_Email: hcpEmail,
              },
              type: 'GET',
            });

            if (res1 === 'true') {
              return true;
            }
          } catch (error) {
            console.log(['Email Already Exist', error]);
          }
        }

        async function validatePhoneNumber(hcpPhoneNumber) {
            if (!hcpPhoneNumber) {
                return { valid: false, message: "Phone is required." };
            }

            try {
                const response = await $.ajax({
                    url: base_url + '/shopifyapp_ajax_call/validatePhoneNumber.php',
                    type: 'POST',
                    data: { phone_number: hcpPhoneNumber },
                    dataType: 'json'
                });

                return response; // { valid: true } OR { valid: false, message: "already exists" }

            } catch (error) {
                return { valid: false, message: "Server error: " + error };
            }
        }

        function isValidEmail(email) {
            const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return pattern.test(email.trim());
        }
  });

  $(document).on("click", ".order_submit_HCP_staff", function (e) {

     e.preventDefault();

    if ($('#HCPStaffPhone').val() === '') {
       Swal.fire({
              icon: 'warning',
              title: 'warning',
              html: `Please Enter phone number`,
              customClass: {
                confirmButton: "Button Button--primary",
            },
        });
        return false;
    }

      $(".order_submit_HCP_staff").prop("disabled", true);

              var address_from = document.address_info_form_hcpStaff;
              var dataString = $(address_from).serialize();


              $.ajax({
                method: "POST",
                url: base_url + '/order_invoice/hcp_staff_address.php',
                data: dataString,
                success: function (response) {
                  let data;

                  $(".order_submit_HCP_staff").prop("disabled", false);

                  try {
                    data = JSON.parse(response);
                  } catch (e) {
                    Swal.fire({
                      icon: "error",
                      title: "Error",
                      text: "Unexpected server response.",
                      customClass: {
                          confirmButton: "Button Button--primary",
                      }
                    });
                    return;
                  }

                  if (data.status === "success") {
                    Swal.fire({
                      icon: "success",
                      title: "Success",
                      text: data.message,
                      customClass: {
                            confirmButton: "Button Button--primary",
                      }
                    });

                  } else {
                    Swal.fire({
                      icon: "error",
                      title: "Error",
                      text: data.message,
                      customClass: {
                        confirmButton: "Button Button--primary",
                      }
                    });
                  }
                },
                error: function () {
                  Swal.fire({
                    icon: "error",
                    title: "Network Error",
                    text: "Failed to send request. Try again!",
                    customClass: {
                      confirmButton: "Button Button--primary",
                    }
                  });
                  $(".order_submit_HCP_staff").prop("disabled", false);

                }
              });

  });

  $(document).on("click", ".my_menu", function (e) {

    if($(this).hasClass('my_pr_recommendation')){
      $('.menu_list_items_heading_top').after(`<h1 style="font-weight: 900 !important;text-align: center;" class="Heading u-h1 welcomeDesing u_d_r_div WelcomeMyOrderText" >Upload Your Dietitian's Recommendation</h1>`);
      $('.menu_list_items_heading_top').hide();
    }else{
      $('.u_d_r_div').remove();
      $('.menu_list_items_heading_top').show();

    }
    
  });
  
});
//# sourceMappingURL=/s/files/1/0319/0859/3723/t/11/assets/menu_list_hcp_client.js.map?v=1697117765
